import { render, staticRenderFns } from "./inventoryStockLevelChartWidget.vue?vue&type=template&id=01cca914&"
import script from "./inventoryStockLevelChartWidget.vue?vue&type=script&lang=js&"
export * from "./inventoryStockLevelChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports